import { useSelector } from 'react-redux';
import StressLevelChart from '../Charts/StressLevelChart';
import {
  selectAverageStressLevel,
  selectStressLevelLabels,
} from '@/redux/selectors/stressLevelSelector';
import dayjs from 'dayjs';
import { getStressLevel } from '@/utils/stressLevelUtils';
import { T } from '@tolgee/react';

const StressLevelChartComponent = () => {
  const labels = useSelector(selectStressLevelLabels);
  const lastLabelDate = labels[0] !== '0' ? dayjs(labels[labels.length - 1]) : null;
  const formattedDate = lastLabelDate ? lastLabelDate.format('MMM DD') : '';

  const averageStressLevel = useSelector(selectAverageStressLevel);
  return (
    <div className="p-12">
      <div className="relative rounded-2xl bg-gradient-to-t from-black via-black to-main overflow-hidden">
        <div className="relative top-4 left-0 py-2 px-5 rounded-lg flex justify-between w-full mb-16">
          <div>
            <p className="text-white text-lg">
              <T>stresstest.result_overview.title.label</T>
            </p>
            <p className="text-white text-base opacity-60">
              <T>{getStressLevel(averageStressLevel)}</T>
            </p>
          </div>
          <div className="cursor-pointer"></div>
        </div>
        <StressLevelChart maxWidth="100%" />
        <div className="flex justify-between items-center p-5 w-4/6 m-auto">
          <div className="text-base opacity-50 text-white p-5">
            {lastLabelDate && formattedDate}
          </div>
          <div className="bg-white opacity-50 w-2 h-2 rounded-full"></div>
          <div className="bg-white opacity-50 w-2 h-2 rounded-full"></div>
          <div className="text-base opacity-50 text-white p-5">
            {lastLabelDate && formattedDate}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StressLevelChartComponent;
